import { inject, Injectable } from '@angular/core';
import { CONFIG } from '@config';
import { GAEvent, GAService, GATag } from '@ga';
import posthog from 'posthog-js';

@Injectable({
  providedIn: 'root',
})
export class TrackingService {
  private readonly config = inject(CONFIG);
  private readonly gaService = inject(GAService);

  initialise(): void {
    if (!this.config.posthog) {
      return;
    }

    posthog.init(this.config.posthog.key, {
      api_host: this.config.posthog.host,
      person_profiles: 'identified_only',
      persistence: 'localStorage',
      defaults: '2026-01-30',
    });
  }

  trackEvent(eventData: GATag): void {
    this.gaService.tag(eventData);
    posthog.capture(GAEvent.GenericEvent, eventData);
  }
}
